import React from "react";
import { Button } from "reactstrap";

export default function PaginationBar({
  page,
  totalPages,
  totalItems,
  pageSize,
  setPage,
  setPageSize,
  pageSizeOptions = [5, 10, 20, 50],
}) {
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div className="d-flex align-items-center justify-content-between gap-2 mt-3 flex-wrap">
      <div className="text-muted" style={{ fontSize: 13 }}>
        Total: <b>{totalItems}</b> • Page <b>{page}</b> / <b>{totalPages}</b>
      </div>

      <div className="d-flex align-items-center gap-2">
        <select
          className="form-select form-select-sm"
          style={{ width: 90 }}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(1);
          }}
        >
          {pageSizeOptions.map((n) => (
            <option key={n} value={n}>
              {n}/page
            </option>
          ))}
        </select>

        <Button
          size="sm"
          color="light"
          disabled={!canPrev}
          onClick={() => setPage(1)}
        >
          «
        </Button>

        <Button
          size="sm"
          color="light"
          disabled={!canPrev}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
        >
          ‹
        </Button>

        <Button
          size="sm"
          color="light"
          disabled={!canNext}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
        >
          ›
        </Button>

        <Button
          size="sm"
          color="light"
          disabled={!canNext}
          onClick={() => setPage(totalPages)}
        >
          »
        </Button>
      </div>
    </div>
  );
}
